import { Injectable } from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";

@Injectable({
  providedIn: 'root'
})
export class FormIngresoService {

  ingresoForm!: FormGroup;
  menajeriaForm!: FormGroup;

  constructor(private fb: FormBuilder) { }

  getIngresoForm(){
    return this.ingresoForm= this.fb.group({
      razonSocial: new FormControl('', {nonNullable: true}),
      ruc: new FormControl('', {nonNullable: true}),
      numFactura: new FormControl('', {nonNullable: true}),
      insumoAlmacen: new FormGroup({
        cantidad: new FormControl('', {nonNullable: true}),
        costo: new FormControl('', {nonNullable: true}),
        unidadMedida: new FormControl('', {nonNullable: true})
      })
    });
  }

  getIngresoEquipoForm(){
    return this.ingresoForm= this.fb.group({
      factura: new FormControl('', {nonNullable: true}),
      equipoAlmacen: new FormGroup({
        marca: new FormControl('', {nonNullable: true}),
        modelo: new FormControl('', {nonNullable: true}),
        talla: new FormControl('', {nonNullable: true}),
        valoracion: new FormControl('', {nonNullable: true}),
        observaciones: new FormControl('', {nonNullable: true}),
        cantidad: new FormControl('', {nonNullable: true}),
        costo: new FormControl('', {nonNullable: true})
      })
    });
  }

  getEquipoForm(){
    return this.ingresoForm= this.fb.group({
      codigo: new FormControl('', {nonNullable: true}),
      nombre: new FormControl('', {nonNullable: true}),
      marca: new FormControl('', {nonNullable: true}),
      modelo: new FormControl('', {nonNullable: true}),
      talla: new FormControl('', {nonNullable: true}),
      categoria: new FormControl('', {nonNullable: true}),
      valoracion: new FormControl('', {nonNullable: true}),
      costo: new FormControl('', {nonNullable: true}),
      observaciones: new FormControl('', {nonNullable: true}),
      razonSocial: new FormControl('', {nonNullable: true}),
      ruc: new FormControl('', {nonNullable: true}),
      numFactura: new FormControl('', {nonNullable: true}),
    });
  }

  getMenajeriaForm(){
    return this.menajeriaForm= this.fb.group({
      nombre: new FormControl('', {nonNullable: true}),
      marca: new FormControl('', {nonNullable: true}),
      modelo: new FormControl('', {nonNullable: true}),
      cantidad: new FormControl('', {nonNullable: true}),
      razonSocial: new FormControl('', {nonNullable: true}),
      ruc: new FormControl('', {nonNullable: true}),
      numFactura: new FormControl('', {nonNullable: true}),
    });
  }
}
